import script from "./DivisionesAutos.vue?vue&type=script&setup=true&lang=js"
export * from "./DivisionesAutos.vue?vue&type=script&setup=true&lang=js"

import "./DivisionesAutos.vue?vue&type=style&index=0&id=af5d5c1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af5d5c1c"]])

export default __exports__